import { useMutation } from 'react-query'
import axios, { AxiosResponse } from 'axios'
import { getAPIUrl } from '../../api/API'
import { Person } from './Precheck'

export type CreditReportCandidateRequest = {
  identityNumber: string
  passportNumber: string
  firstName: string
  lastName: string
  dateOfBirth: string | null
  reference: string
}

export const usePrecheckSearch = (
  values: CreditReportCandidateRequest,
  setCreditSearchResults: (value: Person[]) => void,
  handleError: (e: any) => void,
) => {
  const { mutate: searchCreditReportCandidate, isLoading } = useMutation(
    'credit-candidate',
    async () => {
      const res = await axios.post<any, AxiosResponse<{ data: Person[] }>>(
        getAPIUrl() + '/PreCheck/precheck-match',
        {
          identityNumber: values.identityNumber ? values.identityNumber : null,
          passportNumber: values.passportNumber ?? undefined,
          firstName: values.firstName,
          lastName: values.lastName,
          dateOfBirth: values.dateOfBirth,
          reference: values.reference,
          productId: 235,
          reportType: 10,
        },
        {
          headers: {
            Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
          },
        },
      )
      return res.data
    },
    {
      onSuccess: (response) => {
        setCreditSearchResults(response.data)
      },
      onError: handleError,
    },
  )

  return {
    searchCreditReportCandidate,
    isLoading,
  }
}
function setCreditSearchResults(data: Person[]) {
  throw new Error('Function not implemented.')
}
